import { render } from "./EquipPanel.vue?vue&type=template&id=bf2877aa&scoped=true&ts=true"
import script from "./EquipPanel.vue?vue&type=script&lang=ts"
export * from "./EquipPanel.vue?vue&type=script&lang=ts"

import "./EquipPanel.vue?vue&type=style&index=0&id=bf2877aa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2877aa"]])

export default __exports__